/**
 * Front-end entry point.
 *
 * Gulp concatenates modules/*.js before this file, so everything on the
 * window.Blockline namespace is ready by the time init runs.
 */
( function () {
	'use strict';

	function init() {
		var app = window.Blockline || {};

		Object.keys( app ).forEach( function ( key ) {
			if ( app[ key ] && typeof app[ key ].init === 'function' ) {
				app[ key ].init();
			}
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
